import { EventCatalogFromKeys, EventType } from "../types";

export const OfferEventKeys = {
  ADMIN_NEED_BROWSE_OFFERS_CLICK: "admin-need-browse-offers-click",
  ADMIN_NEED_MATCH_OFFER_SUCCESS: "admin-need-match-offer-success",
  ADMIN_OFFER_CREATE_CLICK: "admin-offer-create-click",
  ADMIN_OFFER_DECLINE_CLICK: "admin-offer-decline-click",
  ADMIN_OFFER_DETAIL_VIEW: "admin-offer-detail-view",
  ADMIN_OFFER_DONATION_COPY_LINK: "admin-offer-donation-copy-link",
  ADMIN_OFFER_DONATION_OPEN_LINK: "admin-offer-donation-open-link",
  ADMIN_OFFER_MARK_FULFILLED_CLICK: "admin-offer-mark-fulfilled-click",
  ADMIN_OFFER_MATCH_TO_NEED_CLICK: "admin-offer-match-to-need-click",
  ADMIN_OFFER_MATCH_TO_NEED_SUCCESS: "admin-offer-match-to-need-success",
  ADMIN_OFFER_STATUS_UPDATE_SUCCESS: "admin-offer-status-update-success",
  ADMIN_OFFER_TABLE_FILTER_AREA: "admin-offer-table-filter-area",
  ADMIN_OFFER_TABLE_FILTER_STATUS: "admin-offer-table-filter-status",
  ADMIN_OFFER_TABLE_FILTER_TYPE: "admin-offer-table-filter-type",
  ADMIN_OFFERS_PAGE_VIEW: "admin-offers-page-view",
  PUBLIC_OFFER_DONATION_FORM_SUBMIT_ATTEMPT:
    "public-offer-donation-form-submit-attempt",
  PUBLIC_OFFER_DONATION_FORM_SUBMIT_FAILURE:
    "public-offer-donation-form-submit-failure",
  PUBLIC_OFFER_DONATION_FORM_SUBMIT_SUCCESS:
    "public-offer-donation-form-submit-success",
  PUBLIC_OFFER_DONATION_FORM_VIEW: "public-offer-donation-form-view",
  PUBLIC_OFFER_THANK_YOU_PAGE_VIEW: "public-offer-thank-you-page-view",
} as const;

export const OfferEventCatalog: EventCatalogFromKeys<typeof OfferEventKeys> = {
  [OfferEventKeys.ADMIN_NEED_BROWSE_OFFERS_CLICK]: {
    description: "Admin clicks to browse offers from need detail page",
    eventType: EventType.INTERACTION,
    id: "admin-need-browse-offers-click",
  },
  [OfferEventKeys.ADMIN_NEED_MATCH_OFFER_SUCCESS]: {
    description:
      "Admin successfully matches offer to need from need detail page",
    eventType: EventType.INTERACTION,
    id: "admin-need-match-offer-success",
  },
  [OfferEventKeys.ADMIN_OFFER_CREATE_CLICK]: {
    description: "Admin clicked create offer button",
    eventType: EventType.INTERACTION,
    id: "admin-offer-create-click",
  },
  [OfferEventKeys.ADMIN_OFFER_DECLINE_CLICK]: {
    description: "Admin declines an offer",
    eventType: EventType.INTERACTION,
    id: "admin-offer-decline-click",
  },
  [OfferEventKeys.ADMIN_OFFER_DETAIL_VIEW]: {
    description: "Admin views offer details",
    eventType: EventType.PAGE_VIEW,
    id: "admin-offer-detail-view",
  },
  [OfferEventKeys.ADMIN_OFFER_MARK_FULFILLED_CLICK]: {
    description: "Admin marks offer as fulfilled",
    eventType: EventType.INTERACTION,
    id: "admin-offer-mark-fulfilled-click",
  },
  [OfferEventKeys.ADMIN_OFFER_MATCH_TO_NEED_CLICK]: {
    description: "Admin clicks to match offer to need",
    eventType: EventType.INTERACTION,
    id: "admin-offer-match-to-need-click",
  },
  [OfferEventKeys.ADMIN_OFFER_MATCH_TO_NEED_SUCCESS]: {
    description: "Admin successfully matches offer to need",
    eventType: EventType.INTERACTION,
    id: "admin-offer-match-to-need-success",
  },
  [OfferEventKeys.ADMIN_OFFERS_PAGE_VIEW]: {
    description: "Admin views the offers management page",
    eventType: EventType.PAGE_VIEW,
    id: "admin-offers-page-view",
  },
  [OfferEventKeys.ADMIN_OFFER_STATUS_UPDATE_SUCCESS]: {
    description: "Admin successfully updates offer status",
    eventType: EventType.INTERACTION,
    id: "admin-offer-status-update-success",
  },
  [OfferEventKeys.ADMIN_OFFER_TABLE_FILTER_AREA]: {
    description: "Admin filters offers table by area",
    eventType: EventType.INTERACTION,
    id: "admin-offer-table-filter-area",
  },
  [OfferEventKeys.ADMIN_OFFER_TABLE_FILTER_STATUS]: {
    description: "Admin filters offers table by status",
    eventType: EventType.INTERACTION,
    id: "admin-offer-table-filter-status",
  },
  [OfferEventKeys.ADMIN_OFFER_TABLE_FILTER_TYPE]: {
    description: "Admin filters offers table by type",
    eventType: EventType.INTERACTION,
    id: "admin-offer-table-filter-type",
  },
  [OfferEventKeys.PUBLIC_OFFER_DONATION_FORM_SUBMIT_ATTEMPT]: {
    description: "User attempts to submit the offer donation form",
    eventType: EventType.INTERACTION,
    id: "public-offer-donation-form-submit-attempt",
  },
  [OfferEventKeys.PUBLIC_OFFER_DONATION_FORM_SUBMIT_FAILURE]: {
    description: "User fails to submit the offer donation form",
    eventType: EventType.INTERACTION,
    id: "public-offer-donation-form-submit-failure",
  },
  [OfferEventKeys.PUBLIC_OFFER_DONATION_FORM_SUBMIT_SUCCESS]: {
    description: "User successfully submits the offer donation form",
    eventType: EventType.INTERACTION,
    id: "public-offer-donation-form-submit-success",
  },
  [OfferEventKeys.PUBLIC_OFFER_DONATION_FORM_VIEW]: {
    description: "User views the public offer donation form",
    eventType: EventType.PAGE_VIEW,
    id: "public-offer-donation-form-view",
  },
  [OfferEventKeys.PUBLIC_OFFER_THANK_YOU_PAGE_VIEW]: {
    description: "User views the offer thank you page",
    eventType: EventType.PAGE_VIEW,
    id: "public-offer-thank-you-page-view",
  },
  [OfferEventKeys.ADMIN_OFFER_DONATION_COPY_LINK]: {
    description:
      "Admin copied the donation offer link in OfferDonationLinkCard",
    eventType: EventType.INTERACTION,
    id: "admin-offer-donation-copy-link",
  },
  [OfferEventKeys.ADMIN_OFFER_DONATION_OPEN_LINK]: {
    description:
      "Admin opened the donation offer link in OfferDonationLinkCard",
    eventType: EventType.INTERACTION,
    id: "admin-offer-donation-open-link",
  },
};
